module.exports = __webpack_public_path__ + "img/BateriaPanelDMPEnActivacion.88b11014.svg";